var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{on:{"click":function($event){return _vm.emitPayload()}}},[_vm._v("\n        Add Test "+_vm._s(_vm._f("capitalize")(_vm.methodVariant))+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }